/**
 * Created by Анжелика on 17.11.2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import * as def from '../constants/defines';

class FormInput extends Component {

    validationError() {
        const {showError, errorText} = this.props;
        return showError && errorText && errorText.length > 0;
    }

    serverError() {
        const {showError, serverErrors} = this.props;
        return showError && serverErrors && serverErrors.length > 0;
    }

    render() {
        const {name, label, placeholder, type, autoFocus, errorText, serverErrors, onFieldChanged} = this.props;
        let errValid = this.validationError();
        let errServ = this.serverError();
        return(
            <div className={"form-group" + (errValid || errServ ? " validation-error" : "")}>
                <label className="control-label">{label}</label>
                <input name={name} placeholder={placeholder} type={type || "text"} autoFocus={autoFocus ? "autoFocus" : ""} onChange={onFieldChanged} maxLength={def.INPUT_MAX_LENGTH} />
                {errValid && <div className="error-text">{errorText}</div>}
                {errServ && serverErrors.map((err, i) => (<div className="error-text" key={i}>{err}</div>))}
            </div>
        )
    }
}

FormInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    type: PropTypes.string,
    autoFocus: PropTypes.bool,
    showError: PropTypes.bool,
    errorText: PropTypes.string,
    serverErrors: PropTypes.array,
    onFieldChanged: PropTypes.func.isRequired
};

export default FormInput;


// WEBPACK FOOTER //
// ./src/components/FormInput.js